import GameMemory from './GameMemory';

export default GameMemory;
